import angular from 'angular';
import assistantSelect from './assistantSelect';

export default angular
  .module('components.assistantSelect', [])
  .component('assistantSelect', assistantSelect).name;
